import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function HotelTable(props: { parentIdx: number }) {
  const { t } = useTranslation();
  const name: any = `approvalable.tourHotels.${props.parentIdx}.details`;
  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:check_in'),
      accessorKey: 'checkIn',
      minSize: 100,
      dataType: ColumnDataType.date,
    },

    {
      header: t('common:check_out'),
      accessorKey: 'checkOut',
      minSize: 100,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:night'),
      accessorKey: 'night',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
    {
      header: t('common:room_type'),
      accessorKey: 'hotelRoomName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:city_tax'),
      accessorKey: 'cityTax',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100' }}>
      <TableEditableComponent
        columns={columns}
        data={value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
